import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { GlobalErrorsHandler } from '../../errors/global-errors.handler';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
  constructor(private errorsHandler: GlobalErrorsHandler) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('api')) {
      const headers: any = {};

      headers['Content-Type'] = 'application/json';

      if (environment.apiUrl && environment.apiUrl !== '/') {
        req = req.clone({
          url: environment.apiUrl + req.url
        });
      }

      req = req.clone({
        setHeaders: headers
      });

      return next.handle(req).pipe(
        switchMap(res => {
          if (this.errorsHandler.isHttpError(res)) {
            this.errorsHandler.handleError(res);
            return throwError(res);
          }

          return of(res);
        }),
        catchError(res => {
          if (this.errorsHandler.isHttpError(res)) {
            this.errorsHandler.handleError(res);
            return throwError(res);
          }

          return throwError(res);
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
